import React, { useState } from 'react';
import AnnouncementsList from './components/AnnouncementList';
import ActionBar from '../../layout/ActionBar';
import Edit from './slideout/Edit';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function Announcements() {
  const [, setPageTitle] = usePageTitle(['Announcements', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>(undefined);
  const [addAnnouncementSlideoutOpen, setAddAnnouncementSlideoutOpen] =
    useState(false);

  return (
    <>
      <ActionBar breadcrumb={[]}>
        <Button
          className="btn btn-primary"
          onClick={() => setAddAnnouncementSlideoutOpen(true)}
          text={t('Add announcement')}
        />
      </ActionBar>
      <AnnouncementsList reload={reload} />

      <SlidingPane
        isOpen={addAnnouncementSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddAnnouncementSlideoutOpen(false)}
      >
        <Edit
          id={undefined}
          done={() => {
            setReload(new Date());
            setAddAnnouncementSlideoutOpen(false);
          }}
          cancel={() => setAddAnnouncementSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default Announcements;
